module.exports = __webpack_public_path__ + "media/images/row1_img2-17766de78b8e31784f0f5ce28c80afa5.jpg";